import { getRuntimeConfig } from './runtimeConfig'

/**
 * Base URL for API requests.
 *
 * Read from the runtime config (`/config.json` fetched on app bootstrap) so
 * a single nginx image can serve every preview environment with its own
 * per-preview API URL — see `src/constants/API/runtimeConfig.ts` and the
 * preview-environments design doc (§4.4).
 *
 * Lazy: returns the value on each call. The previous module-load form
 * (`export const API_URL = getRuntimeConfig().apiUrl`) coupled load order
 * to Rollup's chunking — when Vite hoisted this module's evaluation across
 * the dynamic `import('./bootstrap')` boundary in `src/index.tsx`, the
 * runtime-config singleton wasn't yet populated and the SPA failed to
 * mount with `Runtime config accessed before loadRuntimeConfig() resolved`.
 * Calling `getApiUrl()` per-use is cheap (one property read on a populated
 * singleton) and decouples bundle-graph shape from boot order.
 */
export const getApiUrl = (): string => getRuntimeConfig().apiUrl

/** crm-integrations' base URL, or null where the environment does not configure it. */
export const getCrmIntegrationsUrl = (): string | null => getRuntimeConfig().crmIntegrationsUrl ?? null
